import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../../../utils/LStrings';
import {
    map,
    flatMap,
    forEach
} from 'lodash';
import TableUtils from '../../../../../../../utils/TableUtils';
import TablePlain from '../../../../../../../components/table-plain/TablePlain';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class TableAportes extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data.datos)
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data.datos)
		});
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	processData = (data) => {
		if (data == null)
			return null;

		// datos procesados para mostrar en el reporte
		let info = {};

		const monthsKey = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];


		forEach(data, (item) => {
			// Extraigo el mes
			let month = item.fecpres.substring(5, 7);
			// Extraigo el año
			let year = item.fecpres.substring(0, 4);

			// Compruebo si existen datos para el año del item actual
			if (!info[year]) {
				// Genero la información para el año del item actual
				info[year] = {
					anio: year
				};
				// Inicializo valores por defecto en -1 (sin información)
				forEach(monthsKey, (x) => {
					info[year][x] = null;
				})
			}

			info[year][month] = item.pago;
		});

		let result = flatMap(info, (x) => x);

		return result;
	}

	cellARSFormat(cell) {
		return TableUtils.ARSFormat(cell, false);
	}

    render() {
		return (
			<div>
				<TablePlain columns={[lstrings.agno, lstrings.mes_ene, lstrings.mes_feb, lstrings.mes_mar, lstrings.mes_abr, lstrings.mes_may, lstrings.mes_jun, lstrings.mes_jul, lstrings.mes_ago, lstrings.mes_sep, lstrings.mes_oct, lstrings.mes_nov, lstrings.mes_dic]}
					rows={map(this.state.data, (item, ix) => <tr key={ix}>
						<td>{item.anio}</td>
						<td>{this.chooseIcon(item["01"])}</td>
						<td>{this.chooseIcon(item["02"])}</td>
						<td>{this.chooseIcon(item["03"])}</td>
						<td>{this.chooseIcon(item["04"])}</td>
						<td>{this.chooseIcon(item["05"])}</td>
						<td>{this.chooseIcon(item["06"])}</td>
						<td>{this.chooseIcon(item["07"])}</td>
						<td>{this.chooseIcon(item["08"])}</td>
						<td>{this.chooseIcon(item["09"])}</td>
						<td>{this.chooseIcon(item["10"])}</td>
						<td>{this.chooseIcon(item["11"])}</td>
						<td>{this.chooseIcon(item["12"])}</td>
					</tr>)} />
				<div>{this.showReferences()}</div>
			</div>
        );
	}
	
	chooseIcon(value) {
	    switch (value) {
	        case false:
	            return this.refFueraDeTermino();

	        case true:
	            return this.refEnTermino();

	        default:
	            return this.refNoRegistra();
	    }
	}

	refEnTermino() {
		return <span><i className="fa fa-check-circle" style={{ color: '#8BC34A' }}></i></span>;
	}

	refFueraDeTermino() {
		return <span><i className="fa fa-minus-circle" style={{ color: '#E5E500' }}></i></span>;
	}

	refNoRegistra() {
		return <span><i className="fa fa-circle" style={{ color: '#808080' }}></i></span>;
	}

	showReferences() {
		return <p>{this.refEnTermino()} En término - {this.refFueraDeTermino()} Fuera de término - {this.refNoRegistra()} No registra</p>
	}
}

TableAportes.propTypes = {
    data: PropTypes.any,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default TableAportes;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableAportes.js